import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';
import { MutateFunction, UseMutateResource } from '../../utils/types';

type QuoteVariantInput = TrpcInputs['deleteQuoteVariant'];
type QuoteVariantOutput = TrpcOutputs['deleteQuoteVariant'];

type DeleteQuoteVariantFunction = MutateFunction<QuoteVariantInput, QuoteVariantOutput>;
type UseDeleteQuoteVariant = UseMutateResource<DeleteQuoteVariantFunction>;

export const useDeleteQuoteVariant = (id?: number): UseDeleteQuoteVariant => {
  const { mutateAsync, isLoading, error } = trpc.deleteQuoteVariant.useMutation();

  const handleDelete: DeleteQuoteVariantFunction = () => mutateAsync({ id } as QuoteVariantInput);

  return [handleDelete, isLoading, error?.message];
};
